import {
  // requestTabletList,
  // registTablet,
  // requestTabletDelete
  requestTabletPrint
} from "@/apis/tablet_api";

const state = {
  // tabletList: [],
  // tabletPage: null,
  // tabletPageTotal: 0,
  // tabletTotalElemtnts: 0,
};

const getters = {
  // getTabletList(state) {
  // 	return state.tabletList;
  // },
  // getTabletPage(state) {
  // 	if (state.tabletPage === null) {
  // 		return 0;
  // 	} else {
  // 		return state.tabletPage.pageNumber + 1;
  // 	}
  // },
  // getTabletPageTotal(state) {
  // 	return state.tabletPageTotal;
  // },
  // getTabletTotalElements(state) {
  // 	return state.tabletTotalElemtnts;
  // },
};

const mutations = {
  // TABLET_LIST(state, data) {
  // 	state.tabletList = data.resultTabletList
  // 	state.tabletPage = data.page
  // 	state.tabletPageTotal = data.pageTotal
  // 	state.tabletTotalElemtnts = data.totalElemtnts
  // },
  // TABLET_LIST_ADD(state, data) {
  // 	state.tabletList = [].concat.apply(state.tabletList, data.resultTabletList);
  // 	state.tabletPage = data.page
  // 	state.tabletPageTotal = data.pageTotal
  // 	state.tabletTotalElemtnts = data.totalElemtnts
  // },
  // TABLET_INIT(state) {
  // 	state.tabletList = []
  // 	state.tabletPage = null
  // 	state.tabletPageTotal = 0
  // 	state.tabletTotalElemtnts = 0
  // }
};

const actions = {
  async REQUEST_TABLET_PRINT({ commit }, parameter) {
    try {
      // commit("START_LOADING");
      await requestTabletPrint(parameter);
    } catch (e) {
      if (e === "refresh") {
        return;
      }

      console.error(e);
    } finally {
      commit("END_LOADING");
    }
  }
  // async REQUEST_TABLET_DELETE(context, id) {
  // 	try {
  // 		context.commit('START_LOADING');
  // 		const response = await requestTabletDelete(id);
  // 		if (response.data !== null && response.data !== undefined && response.data.result === 'success') {
  // 			context.commit("TABLET_LIST", response.data);
  // 		} else {
  // 			alert(response.data.message);
  // 		}
  // 		context.commit('END_LOADING');
  // 	} catch (e) { if(e==='refresh'){ return }
  // 		context.commit('END_LOADING');
  // 	}
  // 	context.commit('END_LOADING');
  // },
  // async REQUEST_TABLET_LIST(context, parameter) {
  // 	try {
  // 		context.commit('START_LOADING');
  // 		const response = await requestTabletList(parameter);
  // 		if (response.data !== null && response.data !== undefined && response.data.result === 'success') {
  // 			context.commit("TABLET_LIST", response.data);
  // 		} else {
  // 			alert(response.data.message);
  // 		}
  // 		context.commit('END_LOADING');
  // 	} catch (e) { if(e==='refresh'){ return }
  // 		context.commit('END_LOADING');
  // 	}
  // 	context.commit('END_LOADING');
  // },
  // async REGIST_TABLET(context, parameter) {
  // 	try {
  // 		context.commit('START_LOADING');
  // 		const response = await registTablet(parameter);
  // 		if (response.data !== null && response.data !== undefined && response.data.result === 'success') {
  // 		} else {
  // 			alert(response.data.message);
  // 		}
  // 		context.commit('END_LOADING');
  // 	} catch (e) { if(e==='refresh'){ return }
  // 		context.commit('END_LOADING');
  // 	}
  // 	context.commit('END_LOADING');
  // },
};

export default { mutations, state, actions, getters };
